import type { DomainGroup } from "../types";

export const uiDomain: DomainGroup = {
  id: "ui",
  name: "Interfaz de Usuario",
  description: "Módulos de solo interfaz sin tablas asociadas",
  icon: "Layout",
  order: 1,
  status: "active",

  // ── Configuración i18n del dominio ────────────────────
  i18n: {
    namespace: "ui",
    keys: {
      title: "ui.title",
      description: "ui.description",
    },
  },

  modules: [
    {
      id: "dashboard",
      name: "Dashboard",
      description: "Vista general del sistema",
      icon: "LayoutDashboard",
      permissions: ["canCreate", "canRead", "canUpdate", "canDelete"],
      routes: ["/dashboard", "/super/dashboard"],
      navigation: {
        showInNav: true,
        contexts: ["main"],
        navOrder: 1,
        status: "active",
      },

      i18n: {
        namespace: "ui.dashboard",
        keys: {
          title: "ui.dashboard.title",
          description: "ui.dashboard.description",
          longDescription: "ui.dashboard.longDescription",
          emptyState: "ui.dashboard.emptyState",
          actions: {
            view: "ui.dashboard.actions.view",
          },
        },
        translatableFields: [],
        translatableEnums: [],
      },

      tables: [],
      readOnlyTables: [{ tableName: "companies" }],
    },
    {
      id: "settings",
      name: "Empresa",
      description: "Gestiona la configuración de tu empresa",
      icon: "Settings",
      permissions: ["canCreate", "canRead", "canUpdate", "canDelete"],
      routes: ["/settings"],
      navigation: {
        showInNav: true,
        contexts: ["settings"],
        navOrder: 0,
        status: "active",
      },

      i18n: {
        namespace: "ui.settings",
        keys: {
          title: "ui.settings.title",
          description: "ui.settings.description",
          longDescription: "ui.settings.longDescription",
          emptyState: "ui.settings.emptyState",
          actions: {
            edit: "ui.settings.actions.edit",
            view: "ui.settings.actions.view",
          },
        },
        translatableFields: [],
        translatableEnums: [],
      },

      tables: [],
      readOnlyTables: [{ tableName: "companies" }],
    },
    {
      id: "profiles",
      name: "Perfiles",
      description: "Gestión de perfiles de usuario",
      icon: "User",
      permissions: ["canCreate", "canRead", "canUpdate", "canDelete"],
      routes: ["/profile"],
      navigation: {
        showInNav: false,
        contexts: ["none"],
        navOrder: 999,
        status: "active",
      },

      i18n: {
        namespace: "ui.profiles",
        keys: {
          title: "ui.profiles.title",
          description: "ui.profiles.description",
          longDescription: "ui.profiles.longDescription",
          emptyState: "ui.profiles.emptyState",
          actions: {
            edit: "ui.profiles.actions.edit",
            view: "ui.profiles.actions.view",
          },
        },
        translatableFields: [],
        translatableEnums: [],
      },

      tables: [],
      readOnlyTables: [{ tableName: "users" }],
    },
  ],
};
